export default __webpack_public_path__ + "static/media/event.1d689800.svg";